import React from "react";
//import IsPortrait from '../../helpers/WindowOrientation';

interface Props {
  car: any;
  seat: string;
  enableAnimations: boolean;
  setSeat: (value: string) => void;
}

const BottombarSeat: React.FC<Props> = ({ car, seat, enableAnimations, setSeat}) => {
  
  //const isPortrait: boolean = IsPortrait();

  React.useEffect(() => {
    return () => {
      setSeat('fl');
    };
  }, [setSeat]);
  
  return (
    <div className={`bottombar-menu-seat ${(enableAnimations === true) ? 'enabled':''}`}>
      <div className="bottombar-seat-subcontainer">
        <div className='bottombar-seat-title'>Distribución Asientos</div>
        <div className='bottombar-seat-icon-container'>
          <div className='bottombar-seat-icon-row'>
            <div className={`bottombar-seat-seat-icon fl ${(seat === 'fl') ? 'selected':''}`} onClick={() => {setSeat('fl')}}/>
            <div className={`bottombar-seat-seat-icon fr ${(seat === 'fr') ? 'selected':''}`} onClick={() => {setSeat('fr')}}/>
          </div>
          <div className='bottombar-seat-icon-row'>
            <div className={`bottombar-seat-seat-icon bl ${(seat === 'bl') ? 'selected':''}`} onClick={() => {setSeat('bl')}}/>
            <div className={`bottombar-seat-seat-icon br ${(seat === 'br') ? 'selected':''}`} onClick={() => {setSeat('br')}}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottombarSeat;